import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * cart_items-add operation
 * @param params - Contains path parameters
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const addCartItems = async ({
  params,
  request,
}: {
  params: ApiTypes["cart_items-add"]["parameters"]["path"];
  request: ApiTypes["cart_items-add"]["request"];
}): Promise<ApiTypes["cart_items-add"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["cart_items-add"]["response"]
    >(
      `/api/public/v2025-06/commerce/carts/${params.cart_token}/items`,
      request,
    );
    return response.data;
  } catch (error) {
    handleApiError(
      error as Error,
      "Failed to addCartItems: ${params.cart_token}",
    );
    throw error;
  }
};

/**
 * cart_item-remove operation
 * @param params - Contains path parameters
 * @param query - Contains query parameters
 * @returns Promise resolving to the API response
 */
export const removeCartItem = async ({
  params,
  query,
}: {
  params: ApiTypes["cart_item-remove"]["parameters"]["path"];
  query?: ApiTypes["cart_item-remove"]["parameters"]["query"];
}): Promise<ApiTypes["cart_item-remove"]["response"]> => {
  try {
    const response = await axiosInstance.delete<
      ApiTypes["cart_item-remove"]["response"]
    >(
      `/api/public/v2025-06/commerce/carts/${params.cart_token}/items/${params.item_id}`,
      { params: query },
    );
    return response.data;
  } catch (error) {
    handleApiError(
      error as Error,
      "Failed to removeCartItem: ${params.cart_token}",
    );
    throw error;
  }
};
